import React, { Component } from "react"
// import Heading from "../Global/Heading"
import Img from "gatsby-image"

const getCat = items => {
  let holdItem = items.map(items => {
    return items.node.category
  })
  let holdCategories = new Set(holdItem)
  let categories = Array.from(holdCategories)
  categories = ["All", ...categories]
  return categories
}
export default class Courses extends Component {
  constructor(props) {
    super(props)
    this.state = {
      courses: props.courses.edges,
      mycourses: props.courses.edges,
      mycategories: getCat(props.courses.edges),
    }
  }

  catClicked = category => {
    let all = [...this.state.courses]
    if (category === "All") {
      this.setState(() => {
        return { mycourses: all }
      })
    } else {
      let holdCat = all.filter(({ node }) => node.category === category)
      this.setState(() => {
        return { mycourses: holdCat }
      })
    }
  }

  render() {
    // console.log(this.state.courses);
    return (
      <section className="py-5">
        <div className="container">
          <h1 className="col display-3 text-dark text-center mb-5">Courses</h1>
          <div className="row my-3">
            <div className="col-10 mx-auto text-center">
              {this.state.mycategories.map((category, index) => {
                return (
                  <button
                    type="button"
                    className="btn btn-info m-3 px-3"
                    key={index}
                    onClick={() => {
                      this.catClicked(category)
                    }}
                  >
                    {category}
                  </button>
                )
              })}
            </div>
          </div>
          <div className="row">
            {this.state.mycourses.map(({ node }) => {
              return (
                <div
                  key={node.id}
                  className="col-12 text-center col-sm-12 col-md-6 col-xs-12 mx-auto mb-3"
                >
                  <Img fixed={node.image.fixed} />
                  <div className="flex-grow-1 ">
                    <div className="justify-content-between">
                      <h6 className="mb-0">{node.title}</h6>
                      <h7 className="mb-0 text-success">$ {node.price}</h7>
                    </div>
                    <p className="text-muted">
                      <small>{node.description.description}</small>
                    </p>
                    <button
                      className="btn btn-warning snipcart-add-item"
                      data-item-id={node.id}
                      data-item-name={node.title}
                      data-item-price={node.price}
                      data-item-url="https://ap-ecom-react.netlify.app/"
                      data-item-image={node.image.fixed.src}
                    >
                      join now
                    </button>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </section>
    )
  }
}
